export class BeException extends Error {
  code: number | string | null | undefined;
  prev: Error | undefined;

  constructor(message?: string | null, code?: number | string | null, prev?: Error) {
    super(message || undefined);
    if (Error.captureStackTrace != undefined) {
      Error.captureStackTrace(this, this.constructor);
    }
    this.name = this.constructor.name;
    this.code = code;
    this.prev = prev;
  }
}

export class AuthException extends BeException {
  constructor(message?: string | null, code?: number | string | null, prev?: Error) {
    super(message || 'Access denied', code, prev);
  }
}

export class AccessDeniedException extends BeException {
  constructor(message?: string | null, code?: number | string | null, prev?: Error) {
    super(message || 'Access denied', code, prev);
  }
}

export class NotFoundException extends BeException {
  constructor(message?: string | null, code?: number | string | null, prev?: Error) {
    super(message || 'Resource not found', code, prev);
  }
}

export class BadRequestException extends BeException {
  constructor(message?: string | null, code?: number | string | null, prev?: Error) {
    super(message || 'Bad request', code, prev);
  }
}

export class ValidationException extends BadRequestException {
  fields: any;

  constructor(message?: string | null, fields?: any) {
    super(message);
    this.fields = fields;
  }
}

export class ServerErrorException extends BeException {
  constructor(message?: string | null, code?: number | string | null, prev?: Error) {
    super(message || 'Internal server error', code, prev);
  }
}

export class UnprocessableEntityException extends BeException {
  constructor(message?: string | null, code?: number | string | null, prev?: Error) {
    super(message || 'Unprocessable entity', code, prev);
  }
}

export class LocalException extends Error {
  code: number | string | null | undefined;
  prev: Error | undefined;

  constructor(message?: string | null, code?: number | string | null, prev?: Error) {
    super(message || undefined);
    if (Error.captureStackTrace != undefined) {
      Error.captureStackTrace(this, this.constructor);
    }
    this.name = this.constructor.name;
    this.code = code;
    this.prev = prev;
  }
}

export class NetworkErrorException extends LocalException {
  constructor(message?: string | null, code?: number | string | null, prev?: Error) {
    super(message || 'Network error', code, prev);
  }
}

export const ACC_TOKEN_MISSING: number = 1000;
export const ACC_TOKEN_JWT_EXPIRED: number = 1002;
export const REF_TOKEN_NOT_FOUND = 1007;
export const REF_TOKEN_EXPIRED = 1009;
export const UPLOADED_FILE_TYPE_NOT_ALLOWED: number = 1264;
export const UNABLE_INSERT_DOC_DUE_TO_UNIQUE_KEY: number = 1290;
export const CORRUPT_IMAGE_FILE: number = 1350;
export const UNABLE_CHECK_PHONE_NUMBER_TYPE: number = 1398;
export const NOTARY_BID_STATUS_INVALID_FOR_ACCEPT: number = 1134;